import { InteractiveBrowserCredential } from '@azure/identity';
import { useInteractiveBrowserCredential } from '@internal/plugin-azure-resources-common-react';
import { TokenCredentialAuthenticationProvider } from '@microsoft/microsoft-graph-client/authProviders/azureTokenCredentials';

import { configApiRef, useApi } from '@backstage/core-plugin-api';

export const useAzureToken = (): {
  getToken: () => Promise<{ token: string }>;
  authProvider: TokenCredentialAuthenticationProvider;
  credentials: InteractiveBrowserCredential;
} => {
  const config = useApi(configApiRef);
  const apiUrl = config.getString('kaap.apiUrl');
  const credentials = useInteractiveBrowserCredential();
  const additionalScopes = [`${apiUrl}/.default`];

  const authProvider = new TokenCredentialAuthenticationProvider(credentials, {
    scopes: ['User.Read', 'Group.Read.All'],
  });

  const getToken = async () => {
    return credentials.getToken(additionalScopes);
  };

  return { getToken, credentials, authProvider };
};
